<template>
  <main class="main__simple simple simple--notfound">
    <div class="simple__container container">
      <div class="simple__notfound">
        <h1 v-text="ui.not_found" />
        <router-link class="simple__return more" to='/'>
          <span class="more__text" v-text="ui.return_home" />
          <i class="more__arrow" />
        </router-link>
      </div>
    </div>
  </main>
</template>

<script>
import { mapGetters } from 'vuex'

import page from '@/mixins/page'

export default {
  mixins: [page],
  name: 'PageNotFound',
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['ui'])
  }
}
</script>



// WEBPACK FOOTER //
// src/templates/PageNotFound.vue